import {
  Container,
  Form,
  InnerForm,
  InputFile,
  Loading,
  Modal,
  Text,
  TextArea,
} from "@fluidattacks/design";
import type { FC } from "react";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

import type {
  IUploadDocModalProps,
  IUploadThreatDocsFormValues,
} from "./types";
import { MAX_DESCRIPTION_LENGTH, validationSchema } from "./validations";

const UploadDocModal: FC<IUploadDocModalProps> = ({
  onClose,
  onSubmit,
  modalRef,
  submitting,
}: IUploadDocModalProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Modal
      id={"addMatchesDoc"}
      modalRef={{ ...modalRef, close: onClose }}
      size={"sm"}
      title={t("group.matches.uploadDoc.title")}
    >
      <Form
        cancelButton={{ onClick: onClose }}
        confirmButton={{
          disabled: submitting,
          label: t("group.matches.uploadDoc.continue"),
        }}
        defaultValues={{
          description: "",
          file: undefined as unknown as FileList,
        }}
        onSubmit={onSubmit}
        yupSchema={validationSchema}
      >
        <InnerForm<IUploadThreatDocsFormValues>>
          {({
            formState: { errors },
            register,
            watch,
            setValue,
          }): JSX.Element => {
            return (
              <Fragment>
                <Text size={"md"} textAlign={"left"} wordBreak={"break-word"}>
                  {t("group.matches.uploadDoc.formats")}
                </Text>
                <InputFile
                  accept={
                    ".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  }
                  error={errors.file?.message?.toString()}
                  id={"file"}
                  name={"file"}
                  register={register}
                  required={true}
                  setValue={setValue}
                  watch={watch}
                />
                <TextArea
                  error={errors.description?.message?.toString()}
                  id={"description"}
                  label={t("group.matches.uploadDoc.description")}
                  maxLength={MAX_DESCRIPTION_LENGTH}
                  name={"description"}
                  register={register}
                  required={true}
                  watch={watch}
                />
                {submitting ? (
                  <Container
                    alignItems={"center"}
                    display={"flex"}
                    height={"100%"}
                    justify={"center"}
                  >
                    <Loading color={"red"} label={"Uploading..."} size={"lg"} />
                  </Container>
                ) : undefined}
              </Fragment>
            );
          }}
        </InnerForm>
      </Form>
    </Modal>
  );
};

export { UploadDocModal };
